import React, { useState, useEffect } from "react";
import styles from "./PortalNav.module.css";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import LogoutIcon from '@mui/icons-material/Logout';
import { getCurrentUser, signOut } from 'aws-amplify/auth';
import { useNavigate } from "react-router-dom";

function PortalNav() {
    const [user, setUser] = useState();
    const navigate = useNavigate();

    // Get user
    useEffect(() => {
        if (!user) {
            async function fetchAuthenticatedUser() {
                try {
                    const userData = await getCurrentUser({ bypassCache: false });

                    if(userData.attributes) {
                        setUser(`${userData.attributes.given_name} ${userData.attributes.family_name}`);
                    }
                } catch (err) {
                    console.error("Error fetching authenticated user: ", err);
                    navigate("/auth/login"); // Redirect to the login page
                }
            };
      
            fetchAuthenticatedUser();
        }
    }, [user]); 
    
    async function signOutApp() {
        try {
            await signOut();
            console.log("Signed out!");
            navigate("/"); 
        } catch (error) {
            console.error("Error signing out: ", error);
        }
    }

    return (
        <Navbar className={styles["vertical-nav"]} expand="lg">
            <Container className={`${styles["nav-container"]}`}>
                <div className={styles["nav-header"]}>
                    <Navbar.Brand>
                        <img className={styles["logo"]} src="/assets/images/logo.webp" alt="logo" />
                    </Navbar.Brand>

                    <p className={styles["user"]}>
                        {user}
                    </p>
                </div>

                <hr className={styles["vertical-nav-divider"]} />
        
                <Navbar.Toggle aria-controls="basic-navbar-nav" />

                <Navbar.Collapse className={`${styles["nav-item-container"]} ${styles["footer-items-container"]}`} id="basic-navbar-nav">
                    <Nav className={styles["nav-item-content"]}>
                        <Nav.Link 
                            className={`${styles["nav-item"]} ${styles["greyed-nav-item"]}`} 
                            href={process.env.REACT_APP_PHYSIOLOGY_DOCS_PAGE}
                            target="__blank" 
                            rel="noopener noreferrer"
                        >
                            Documentation
                        </Nav.Link>
                    </Nav>

                    <Nav className={styles["nav-item-content"]}>
                        <Nav.Link 
                            className={`${styles["nav-item"]} ${styles["portal-footer-nav-item"]}`} 
                            onClick={signOutApp}
                        >
                            <LogoutIcon className={`${styles["nav-item-icon"]} ${styles["nav-footer-icon"]}`} />
                            Logout
                        </Nav.Link>
                    </Nav>

                    <p className={styles["versioning"]}>v.2</p>
                </Navbar.Collapse>
            </Container>
         </Navbar>
    );
}

export default PortalNav;